import { TableCell, TableRow } from '@mui/material'
import React from 'react'
// import { unitMeasureShortText } from '../../../../../../helpers/unitMeasure/UnitMeasureHelper'
import { useSelector } from 'react-redux'

const SupplyOrderBillItemShort = ({ index, supplyBillItem }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[supplyBillItem.unitMeasure] ? unitMeasures[supplyBillItem.unitMeasure].name : '?'

  return (
    <TableRow>
        <TableCell align='center'>
            {
				index + 1
			}
            {/* {
                ` (${supplyBillItem.id})`
            } */}
        </TableCell>
        <TableCell align='center' className='wordBreakAll'>
            {
				supplyBillItem.name
			}
        </TableCell>
        <TableCell align='center'>
            {
				// supplyBillItem.count + ' ' + unitMeasureShortText[supplyBillItem.unitMeasure]
				supplyBillItem.count + ' ' + unitMeasure
			}
        </TableCell>
    </TableRow>
  )
}

export default SupplyOrderBillItemShort